import {
    CreateGenInfoActionTypes,
    CreateBankDetailsActionTypes,
    // GetGenInfoActionTypes,
    CreateGenInfoRequestSubmitActionTypes,
} from '../actionsTypes';

const initialState = {
    isCreatingGenInfoSave: false,
    creategeninfo: {},
    createbankdetails: {},
    createincometax: {},
    createtraveloutside: {},
    createdirectorycompany: {},
    createGenInfoErrorSave: '',
    creategeninfoerrorsubmit: '',
    creategeninfosave: {},
    isCreatingBankDetailsSave: false,
    createbankdetailssave: {},
    createBankDetailsErrorSave: '',
    createdifferentsources: {},

    createassestshome: {},
    clientaccordian1request: {},
    clientaccordian2request: {},
    clientaccordian3request: {},
    clientaccordian4request: {},
    clientaccordian5request: {},
    clientaccordian6request: {},
    clientaccordian7request: {},
    clientaccordian8request: {},
    clientaccordian9request: {},
    clientaccordian10request: {},

    creategeninfosumbit: {},

    createtotalincomelabela: {},
    createtotalincomelabelb: {},
    createtotalincomelabelc: {},
    createtotalincomelabeld: {},
    createtotalincomelabele: {},
    createaddadditionalQue: {},
    isGettingGenInfo: false,
    getgeninfo: {},
    gettingGenInfoError: '',
    crcsaveresults: {},
};

const GenInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GenInfoType':
            return {
                ...state,
                creategeninfo: action.payload,
            };
        case 'BankDetailsType':
            return {
                ...state,
                createbankdetails: action.payload,
            };
        case 'IncomeTaxType':
            return {
                ...state,
                createincometax: action.payload,
            };
        case 'TravelOutsideType':
            return {
                ...state,
                createtraveloutside: action.payload,
            };
        case 'DirectoryCompanyType':
            return {
                ...state,
                createdirectorycompany: action.payload,
            };
        case 'DifferentSourceType':
            return {
                ...state,
                createdifferentsources: action.payload,
            };

        case 'CreateAssestsHome':
            return {
                ...state,
                createassestshome: action.payload,
            };
        case 'ClientAccordian1Request':
            return {
                ...state,
                clientaccordian1request: action.payload,
            };
        case 'ClientAccordian2Request':
            return {
                ...state,
                clientaccordian2request: action.payload,
            };
        case 'ClientAccordian3Request':
            return {
                ...state,
                clientaccordian3request: action.payload,
            };
        case 'ClientAccordian4Request':
            return {
                ...state,
                clientaccordian4request: action.payload,
            };
        case 'ClientAccordian5Request':
            return {
                ...state,
                clientaccordian5request: action.payload,
            };
        case 'ClientAccordian6Request':
            return {
                ...state,
                clientaccordian6request: action.payload,
            };
        case 'ClientAccordian7Request':
            return {
                ...state,
                clientaccordian7request: action.payload,
            };
        case 'ClientAccordian8Request':
            return {
                ...state,
                clientaccordian8request: action.payload,
            };
        case 'ClientAccordian9Request':
            return {
                ...state,
                clientaccordian9request: action.payload,
            };
        case 'ClientAccordian10Request':
            return {
                ...state,
                clientaccordian10request: action.payload,
            };
        case 'CreateTotalIncomeLabelA':
            return {
                ...state,
                createtotalincomelabela: action.payload,
            };
        case 'CreateTotalIncomeLabelB':
            return {
                ...state,
                createtotalincomelabelb: action.payload,
            };
        case 'CreateTotalIncomeLabelC':
            return {
                ...state,
                createtotalincomelabelc: action.payload,
            };
        case 'CreateTotalIncomeLabelD':
            return {
                ...state,
                createtotalincomelabeld: action.payload,
            };
        case 'CreateTotalIncomeLabelE':
            return {
                ...state,
                createtotalincomelabele: action.payload,
            };
        case 'PanelIndexUpdate':
            return {
                ...state,
                panelindexupdate: action.payload,
            };
        case CreateGenInfoActionTypes.INPROGRESS:
            return {
                ...state,
                isCreatingGenInfoSave: true,
            };
        case CreateGenInfoActionTypes.SUCCESS:
            return {
                ...state,
                creategeninfosave: action.payload,
            };
        case CreateGenInfoActionTypes.FAILED:
            return {
                ...state,
                isCreatingGenInfoSave: false,
                createGenInfoErrorSave: action.error,
            };
        case CreateGenInfoActionTypes.RESET_ERROR:
            return {
                ...state,
                createGenInfoErrorSave: '',
            };
        case CreateBankDetailsActionTypes.INPROGRESS:
            return {
                ...state,
                isCreatingBankDetailsSave: true,
            };
        case CreateBankDetailsActionTypes.SUCCESS:
            return {
                ...state,
                createbankdetailssave: action.payload,
            };
        case CreateBankDetailsActionTypes.FAILED:
            return {
                ...state,
                isCreatingBankDetailsSave: false,
                createBankDetailsErrorSave: action.error,
            };
        case CreateBankDetailsActionTypes.RESET_ERROR:
            return {
                ...state,
                createBankDetailsErrorSave: '',
            };

        case 'GetGenInfoRequest':
            return {
                ...state,
                getgeninfo: action.payload,
            };
        case 'CRCSaveResults':
            return {
                ...state,
                crcsaveresults: action.payload,
            };
        case 'CreateAddAdditionalQue':
            return {
                ...state,
                createaddadditionalQue: action.payload,
            };

        // case CreateGenInfoRequestSubmitActionTypes.INPROGRESS:
        //     return {
        //         ...state,
        //         isCreatingGenInfoSave: true,
        //     };
        case CreateGenInfoRequestSubmitActionTypes.SUCCESS:
            return {
                ...state,
                creategeninfosumbit: action.payload,
            };
        case CreateGenInfoRequestSubmitActionTypes.FAILED:
            return {
                ...state,
                isCreatingGenInfoSave: false,
                creategeninfoerrorsubmit: action.error,
            };
        // case CreateGenInfoRequestSubmitActionTypes.RESET_ERROR:
        //     return {
        //         ...state,
        //         createGenInfoErrorSave: '',
        //     };

        default:
            return state;
    }
};

export default GenInfoReducer;
